module.exports = __webpack_public_path__ + "static/media/translucent.c7073a18.png";